var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/BimElementReferenceItems.ts";
import * as t from 'io-ts';
import { BimReference } from './BimReference';
import { Id } from './Id';
import { Version } from './Version';
export var BimElementReferenceItems;

(function (_BimElementReferenceItems) {
  var io = _BimElementReferenceItems.io = t.recursion('BimElementReferenceItems', function () {
    return t.type({
      type: t.literal('BimElementReferenceItems'),
      parentGroupId: t.number,
      parentClassifierId: Id,
      parentClassifierVersion: Version,
      bimElementReferences: t.array(BimReference.Element.io)
    }, 'BimElementReferenceItems');
  });

  var is = _BimElementReferenceItems.is = function (entity) {
    return entity.type === 'BimElementReferenceItems';
  };
})(BimElementReferenceItems || (BimElementReferenceItems = {}));